export const STORE_INIT_ACTION_TYPES = '@@INIT';
